import React, { useState } from "react";
import { Routes, Route, NavLink, Outlet } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faWallet, faReceipt, faCircleCheck, faBook, faList, faUsers, faUser, faDroplet } from '@fortawesome/free-solid-svg-icons';
import ProfileAvatar from "../assets/avatar.jpg";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import { Logout } from "../utils/Logout";
import FullScreenToggle from "../utils/FullScreenToggle";

export default function Dashboard() {
  const [actionDialog, setActionDialog] = useState(false);
  const [openChangePasswordDialog, setOpenChangePasswordDialog] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [formData, setFormData] = useState({
    id: localStorage.getItem('userId'),
    old_password: "",
    new_password: ""
  })

  const openActionDialog = () => {
    setActionDialog(true);
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
        ...prevData,
        [name]: value, 
    }));
  };

  const handleSubmit = () => {
    if (formData.old_password.length == 0) {
      setShowErrorDialog(true);
      setErrorMessage('Enter current password');
      return;
    }

    if (formData.new_password.length == 0) {
      setShowErrorDialog(true);
      setErrorMessage('Enter new password');
      return;
    }

    if (formData.new_password != confirmPassword) {
      setShowErrorDialog(true);
      setErrorMessage('Confirm password does not match');
      return;
    }
    console.log(localStorage.getItem('userId'))

    fetch(`${process.env.REACT_APP_API_ENDPOINT}/auth/${localStorage.getItem('userId')}/password`, {
      method: 'PATCH',
      headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
        if (!response.ok) {
            return response.json().then((data) => {
                setAlertMessage(data.message);
                setAlertSeverity("error");
                setAlertVisible(true);
                setTimeout(() => {
                    setAlertVisible(false);
                }, 2000);
                throw data;
            })
        }
        const data = response.json();
    })
    .then(() => {
        setOpenChangePasswordDialog(false);
        setAlertMessage(`Password has been successfully updated`);
        setAlertSeverity("success");    
        setAlertVisible(true);
        setTimeout(() => {
            setAlertVisible(false);
        }, 2000);
    })
    .catch((error) => {
        setShowErrorDialog(true);
        setErrorMessage(error.message);
        setAlertMessage(error.message);
        setTimeout(() => {
            setAlertVisible(false);
        }, 2000)
    })
  }
    return (
      <div
        className="bg-cover bg-center w-full h-[100dvh] flex flex-col md:justify-center md:items-center"
        style={{ backgroundImage: `url('/background-update.png')` }}
      >
        <div className="my-5 h-[10dvh]">
          <h1 className="text-stroke text-2xl md:text-3xl xl:text-5xl font-bold text-center">Welcome to Room Management System!</h1>
        </div>
        <div className="w-full grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-12 justify-center items-center px-10 h-[70dvh] md:h-[60dvh]">

            <div className=" w-full mx-0 mb-5">
              <NavLink to="/payment">
                <div className="flex flex-col bg-[#0077B6] text-white rounded-lg md:rounded-2xl lg:w-[100%] py-3 lg:py-10 justify-center items-center shadow-lg">
                  <div className="flex flex-col items-center justify-center py-2 lg:py-0">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl md:mb-2 font-semibold">ទូទាត់ប្រាក់</h2>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-7 md:size-12 lg:size-16 mt-2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className="w-full mx-0 mb-5">
              <NavLink to="/room">
                <div className="flex flex-col bg-[#0077B6] text-white rounded-lg md:rounded-2xl lg:w-[100%] py-3 lg:py-10 justify-center items-center shadow-lg">
                  <div className="flex flex-col items-center justify-center py-2 lg:py-0">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl md:my-2 md:mt-0 md:mb-2 font-semibold">ទិន្នន័យអ្នកជួល</h2>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-7 md:size-12 lg:size-16 mt-2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                    </svg>
                  </div>
                </div>
              </NavLink>
            </div>
          
            <div className="w-full mx-0 mb-5">
              <NavLink to="/monthly-report">
                <div className="flex flex-col bg-[#0077B6] text-white rounded-lg md:rounded-2xl lg:w-[100%] py-3 lg:py-10 justify-center items-center shadow-lg">
                  <div className="flex flex-col items-center justify-center py-2 lg:py-0">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl md:mb-2 font-semibold">បញ្ជីប្រចាំខែ</h2>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-7 md:size-12 lg:size-16 mt-2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className="w-full mx-0 mb-5">
              <NavLink to="/building-map">
                <div className="flex flex-col bg-[#0077B6] text-white rounded-lg md:rounded-2xl lg:w-[100%] py-3 lg:py-10 justify-center items-center shadow-lg">
                  <div className="flex flex-col items-center justify-center py-2 lg:py-0">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl md:mb-2 font-semibold">ផែនទីអគារ</h2>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"  className="size-7 md:size-12 lg:size-16 mt-2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
                    </svg>
                  </div>
                </div>
              </NavLink>
            </div>
          
            <div className="w-full mx-0 mb-5 ">
              <NavLink to="/payment-report">
                <div className="flex flex-col bg-[#0077B6] text-white rounded-lg md:rounded-2xl lg:w-[100%]  py-3 lg:py-10 justify-center items-center shadow-lg">
                  <div className="flex flex-col items-center justify-center py-2 lg:py-0">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl md:mb-2 font-semibold">បញ្ជីបង់ប្រាក់</h2>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-7 md:size-12 lg:size-16 mt-2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z" />
                    </svg>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className="w-full mx-0 mb-5">
              <NavLink to="/electricity-report">
                <div className="flex flex-col bg-[#0077B6] text-white rounded-lg md:rounded-2xl lg:w-[100%] py-3 lg:py-10 justify-center items-center shadow-lg">
                  <div className="flex flex-col items-center justify-center py-2 lg:py-0">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl md:mb-2 font-semibold">ទឹក ភ្លើង</h2>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-7 md:size-12 lg:size-16 mt-2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className="w-full mx-0 mb-5">
              <NavLink to="/vehicle">
                <div className="flex flex-col bg-[#0077B6] text-white rounded-lg md:rounded-2xl lg:w-[100%] py-3 lg:py-10 justify-center items-center shadow-lg">
                  <div className="flex flex-col items-center justify-center py-2 lg:py-0">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl md:mb-2 font-semibold">យានជំនិះ</h2>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-7 md:size-12 lg:size-16 mt-2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                    </svg>

                  </div>
                </div>
              </NavLink>
            </div>
          
            <div className="w-full mx-0 mb-5 ">
              <NavLink to="/invoice">
                <div className="flex flex-col bg-[#0077B6] text-white rounded-lg md:rounded-2xl lg:w-[100%] py-3 lg:py-10 justify-center items-center shadow-lg">
                  <div className="flex flex-col items-center justify-center py-2 lg:py-0">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl md:mb-2 font-semibold">វិក័យប័ត្រ</h2>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-7 md:size-12 lg:size-16 mt-2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75" />
                    </svg>
                  </div>
                </div>
              </NavLink>
            </div>
          
          </div>
          <div className="flex items-center text-start justify-start w-full px-10 pt-6 md:pt-14 pb-2">
            <button className="flex px-4 py-2 items-center w-60 md:w-80 hover:bg-gray-600 hover:rounded-lg"onClick={openActionDialog}>
              <img src={ProfileAvatar} alt="avatar" className="w-14 md:w-16 mr-5 rounded-full" />
              <strong className="text-white text-lg md:text-2xl">{localStorage.getItem('name')}</strong>
            </button>
            <FullScreenToggle />
          </div>

          <Dialog open={actionDialog} onClose={() => setActionDialog(false)}>
            <div className="p-4 min-w-[320px] max-w-md mx-auto">
              {/* Profile Section */}
              <div className="flex items-center gap-4 mb-4 p-2 rounded-lg hover:bg-gray-50 transition-colors">
                <img 
                  src={ProfileAvatar} 
                  alt="avatar" 
                  className="w-14 h-14 rounded-full object-cover shadow-sm" 
                />
                <strong className="text-xl text-gray-900">
                  {localStorage.getItem('name')}
                </strong>
              </div>

              {/* Change Password Button */}
              <button 
                className="w-full flex items-center gap-3 px-4 py-3 text-lg text-gray-700 hover:bg-gray-50 rounded-lg transition-colors" 
                onClick={() => setOpenChangePasswordDialog(true)}
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  strokeWidth={1.5} 
                  stroke="currentColor" 
                  className="w-6 h-6"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z" 
                  />
                </svg>
                Change password
              </button>

              {/* Separator */}
              <div className="h-px bg-gray-200 my-2" />

              {/* Logout Button */}
              <button 
                className="w-full flex items-center gap-3 px-4 py-3 text-lg text-red-600 hover:bg-red-50 rounded-lg transition-colors" 
                onClick={Logout}
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 24 24" 
                  fill="currentColor" 
                  className="w-6 h-6"
                >
                  <path 
                    fillRule="evenodd" 
                    d="M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z" 
                    clipRule="evenodd" 
                  />
                </svg>
                Log out
              </button>
            </div>
          </Dialog>

          <Dialog open={openChangePasswordDialog} onClose={() => setOpenChangePasswordDialog(false)} sx={{
                '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                    fontFamily: 'Kantumruy Pro, sans-serif',
                    width: "400px"
                }
            }}>
                <DialogTitle>Change password</DialogTitle>
                <DialogContent>
                <form onSubmit={handleSubmit}>
                        <TextField
                        margin="dense"
                        label="Current password *"
                        name="old_password"
                        type="password"
                        value={formData.old_password !== null ? formData.old_password : ''}
                        onChange={handleInputChange}
                        fullWidth
                        InputLabelProps={{
                            style: { fontFamily: 'Kantumruy Pro' },
                        }}
                        InputProps={{
                            style: {
                              borderRadius: "8px",
                              fontFamily: 'Kantumruy Pro',
                            }
                        }}
                        />
                    <TextField
                        margin="dense"
                        label="New password *"
                        name="new_password"
                        type="password"
                        value={formData.new_password !== null ? formData.new_password : ''}
                        onChange={handleInputChange}
                        fullWidth
                        InputLabelProps={{
                            style: { fontFamily: 'Kantumruy Pro' },
                        }}
                        InputProps={{
                            style: {
                              borderRadius: "8px",
                              fontFamily: 'Kantumruy Pro',
                            }
                        }}
                    />
                    <TextField
                        margin="dense"
                        label="Confirm password *"
                        name="confirmPassword"
                        value={confirmPassword}
                        type="password"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        fullWidth
                        InputLabelProps={{
                            style: { fontFamily: 'Kantumruy Pro' },
                        }}
                        InputProps={{
                            style: {
                            borderRadius: "8px",
                            fontFamily: 'Kantumruy Pro',
                            }
                        }}
                    />
                </form>
                </DialogContent>
                <DialogActions sx={{marginBottom: "16px"}}>
                <Button onClick={() => setOpenChangePasswordDialog(false)} color="black"  
                sx={{paddingY: "8px", paddingX: "32px", marginRight: "16px",'&:hover': {
                    backgroundColor: '#f9f9f9',
                }, }}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit} sx={{background: "#00B4D8", color: "white", paddingY: "8px", paddingX: "32px", marginRight: "16px" }}>
                    Save
                </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showErrorDialog} onClose={() => setShowErrorDialog(false)} sx={{
                '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                    fontFamily: 'Kantumruy Pro, sans-serif',
                }
            }}>
                <DialogTitle sx={{color: "red"}}>Error</DialogTitle>
                <DialogContent>
                    <div style={{ whiteSpace: 'pre-line' }}>
                        {errorMessage}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowErrorDialog(false)} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {alertVisible && (
                <Stack sx={{ width: '100%', justifyContent: "flex-end",
                    alignItems: "flex-end", }}  mt={-5} spacing={2} borderRadius={2}>
                    <Alert severity={alertSeverity} sx={{fontWeight: 500, fontSize: '16px'}}>
                        {alertMessage}
                    </Alert>
                </Stack>
            )}
      </div>
    )
}